// Ícones de traço (mesmos desenhos do canvas "Yuha — Novo Layout").

const PATHS = {
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  arrowLeft: 'M19 12H5M11 18l-6-6 6-6',
  chevronDown: 'M6 9l6 6 6-6',
  check: 'M5 12l5 5L20 7',
  x: 'M6 6l12 12M18 6L6 18',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  menu: 'M4 7h16M4 12h16M4 17h16',
  user: 'M20 21v-1a6 6 0 0 0-6-6h-4a6 6 0 0 0-6 6v1M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  phone:
    'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z',
  mail: 'M4 4h16v16H4zM4 6l8 7 8-7',
  badge: 'M4 7h16v13H4zM9 7V4h6v3',
  message: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  instagram:
    'M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zM16 11.4A4 4 0 1 1 12.6 8 4 4 0 0 1 16 11.4zM17.5 6.5h.01',
  linkedin:
    'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2zM4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  db: 'M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  mobile: 'M7 2h10v20H7zM11 18h2',
  pulse: 'M3 12h4l3-8 4 16 3-8h4',
  share:
    'M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8.6 13.5l6.8 4M15.4 6.5l-6.8 4',
  bars: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  tool: 'M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.5-.5-.5-2.5z',
  doc: 'M6 2h9l5 5v15H6zM14 2v6h6M9 13h6M9 17h6',
  dollar: 'M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  mega: 'M3 11v2l13 5V6zM16 8a4 4 0 0 1 0 8M7 13v5h3',
  userAdd:
    'M15 20v-1a5 5 0 0 0-10 0v1M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM19 8v6M22 11h-6',
  search:
    'M6 2h9l5 5v5M14 2v6h6M6 2v20h5M16 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM21 22l-2.8-2.8',
  nodes:
    'M6 3v12M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 9a9 9 0 0 1-9 9',
  dash: 'M3 3h8v10H3zM13 3h8v6h-8zM13 11h8v10h-8zM3 15h8v6H3z',
  funnel: 'M3 4h18l-7 8v6l-4 2v-8z',
  link: 'M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.5 1.5M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.5-1.5',
  robot: 'M5 8h14v12H5zM12 4v4M9 13h.01M15 13h.01M9 17h6',
  wand: 'M15 4V2M15 10V8M11 6h2M17 6h2M3 21l12-12M13 7l2 2',
  code: 'M16 18l6-6-6-6M8 6l-6 6 6 6',
  rocket:
    'M4.5 16.5c-1.5 1.3-2 5-2 5s3.7-.5 5-2c.7-.8.7-2.1-.1-2.9a2.2 2.2 0 0 0-2.9-.1zM12 15l-3-3a22 22 0 0 1 2-3.9A12.9 12.9 0 0 1 22 2c0 2.7-.8 7.5-6 11a22.4 22.4 0 0 1-4 2zM9 12H4s.6-3 2-4c1.6-1.1 5 0 5 0M12 15v5s3-.6 4-2c1.1-1.6 0-5 0-5',
  palette:
    'M12 22a10 10 0 1 1 10-10c0 2.8-2.2 4-4 4h-2a2 2 0 0 0-1 3.7A1.5 1.5 0 0 1 12 22zM7.5 11.5h.01M10.5 7.5h.01M15.5 8.5h.01',
  layout: 'M3 3h18v18H3zM3 9h18M9 21V9',
  click: 'M4 4l7 17 2.5-7.5L21 11z',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  timer: 'M10 2h4M12 14l3-3M12 22a8 8 0 1 0 0-16 8 8 0 0 0 0 16z',
  alert:
    'M12 9v4M12 17h.01M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
  userX:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM17 8l5 5M22 8l-5 5',
  store: 'M4 9h16l-1-5H5zM5 9v11h14V9M9 20v-6h6v6',
  grid: 'M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z',
  home: 'M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z',
  brush: 'M14 4l6 6-8 8H6v-6zM4 20h4',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7',
  target:
    'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z',
} as const;

export type IconName = keyof typeof PATHS;

/** Texto alternativo de cada ícone (usado quando o ícone não é só decorativo). */
export const ICON_LABELS: Record<IconName, string> = {
  arrowRight: 'Seta para a direita',
  arrowLeft: 'Seta para a esquerda',
  chevronDown: 'Seta para baixo',
  check: 'Sim',
  x: 'Não',
  plus: 'Mais',
  minus: 'Menos',
  menu: 'Menu',
  user: 'Usuário',
  phone: 'Telefone',
  mail: 'E-mail',
  badge: 'Cargo',
  message: 'Mensagem',
  calendar: 'Calendário',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  db: 'Banco de dados',
  mobile: 'Celular',
  pulse: 'Tempo real',
  share: 'Compartilhar',
  bars: 'Gráfico de barras',
  tool: 'Ferramenta',
  doc: 'Relatório',
  dollar: 'Dinheiro',
  mega: 'Megafone',
  userAdd: 'Adicionar usuário',
  search: 'Buscar em arquivo',
  nodes: 'Jornada',
  dash: 'Dashboard',
  funnel: 'Funil',
  link: 'Link',
  robot: 'Robô',
  wand: 'Varinha mágica',
  code: 'Código',
  rocket: 'Foguete',
  palette: 'Paleta de cores',
  layout: 'Layout',
  click: 'Clique',
  eye: 'Visualizações',
  timer: 'Cronômetro',
  alert: 'Alerta',
  userX: 'Usuário sem interação',
  store: 'Loja',
  grid: 'Grade',
  home: 'Início',
  brush: 'Pincel',
  refresh: 'Atualizar',
  target: 'Alvo',
};

type IconProps = {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  /** Texto alternativo. Sem ele o ícone é decorativo (escondido de leitores de tela). */
  title?: string;
};

export function Icon({
  name,
  size = 18,
  strokeWidth = 2,
  className,
  title,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
